import 'scss/solutions/flying-fish-suite.scss'
import 'babel-polyfill'
import 'js/libs/utils-solutions'



// WEBPACK FOOTER //
// ./src/js/entry/solutions/flying-fish-suite.js